// extracted by mini-css-extract-plugin
module.exports =  {"error":"yVcGTe","checkbox":"YOr8Tv"};